/* eslint-disable */
const state = {
  userInfo:{}
}
export default state
